import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import * as Page from '../../lib/page';
import { trackPage } from '../../lib/analytics-helper';
import { fetchDefaultPCCArticles } from './action-default-PCC';
import { fetchICFContents } from './action-icf-guide';

const BNAPromptURL = '/smarthelp/prompt-bna';

function requestPopularQuestions() {
  return {
    type: types.REQUEST_POPULAR_LIST,
  };
}


function receivePopularQuestions(response, experience) {
  const articles = _get(response, 'recommendedSolutions');
  return {
    type: types.RECEIVE_POPULAR_LIST,
    payload: {
      experience,
      articles,
    },
  };
}

function receivePopularQuestionsError() {
  return {
    type: types.RECEIVE_POPULAR_ERROR,
  };
}

// Send Impression event for each BNA article data in the popular article
function BNAImpressionTracker(response) {
  if (!response || !Array.isArray(response.recommendedSolutions) || response.recommendedSolutions.length <= 0) {
    return null;
  }

  const BNAList = response.recommendedSolutions.filter(article => article.channel === 'BNA');
  if (BNAList.length > 0) {
    // PCC prompt FPTI event
    BNAList.forEach((article) => {
      trackPage({ id: 'PCCTrackingPage', link: 'smarthelp-home-pcc', hpid: article.articleId });
    });

    // PCC/BNA prompt event for each BNA article
    return axios.post(BNAPromptURL, {
      _csrf: Page.getCSRFtoken(),
      BNAList: JSON.stringify(BNAList),
    }).catch(() => {});
  }
}

function requestBNAPrompt(response) {
  BNAImpressionTracker(response);
  return {
    type: types.BNA_PROMPT_REQUEST,
  };
}

export default function getPopularQuestions(experience) {
  return (dispatch) => {
    dispatch(requestPopularQuestions());
    // Getting ELMO experiments for PCC design and ICF Guide articles
    const recommendUrl = '/smarthelp/recommended-solutions';
    return axios.get(Page.setChannelForTechnicalExp(recommendUrl))
      .then((response) => {
        dispatch(receivePopularQuestions(response.data, experience));

        dispatch(requestBNAPrompt(response.data));

        fetchDefaultPCCArticles(dispatch, response.data);

        fetchICFContents({ dispatch, remoteData: Page.getIcfMapping(), recommendArticles: response.data.recommendedSolutions });
      })
      .catch(() => {
        dispatch(receivePopularQuestionsError());
      });
  };
}
